import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { logWebAppOpenOnce } from './analytics/webAnalytics';
import { ThemeLanguageProvider } from './context/ThemeLanguageContext';
import LandingPage from './components/LandingPage';
import ReportPage from './components/ReportPage';
import MonthlyReportsPage from './components/MonthlyReportsPage';
import NadlanPage from './components/NadlanPage';
import RaicmanPage from './components/RaicmanPage';
import SnakeGame from './components/SnakeGame';
import MemoryCardGame from './components/MemoryCardGame';
import SpaceInvadersGame from './components/SpaceInvadersGame';
import SlotMachineGame from './components/SlotMachineGame';
import PokerGame from './components/PokerGame';
import BlackjackGame from './components/BlackjackGame';
import ContinueOnMobileMinisite from './components/ContinueOnMobileMinisite';
import ClarityTracker from './components/ClarityTracker';

function App() {
  useEffect(() => {
    logWebAppOpenOnce();
  }, []);

  return (
    <ThemeLanguageProvider>
      <ClarityTracker />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/report" element={<ReportPage />} />
        <Route path="/monthly-reports" element={<MonthlyReportsPage />} />
        <Route path="/nadlan" element={<NadlanPage />} />
        <Route path="/raicman" element={<RaicmanPage />} />
        <Route path="/miluim" element={<Navigate to="/" replace />} />
        <Route path="/technion" element={<Navigate to="/" replace />} />
        <Route path="/minisite/snake" element={<SnakeGame />} />
        <Route path="/minisite/memory" element={<MemoryCardGame />} />
        <Route path="/minisite/space-invaders" element={<SpaceInvadersGame />} />
        <Route path="/minisite/slots" element={<SlotMachineGame />} />
        <Route path="/minisite/poker" element={<PokerGame />} />
        <Route path="/minisite/blackjack" element={<BlackjackGame />} />
        <Route path="/minisite/continue-mobile" element={<ContinueOnMobileMinisite />} />
      </Routes>
    </ThemeLanguageProvider>
  );
}

export default App;
